import { ButtonDS, CheckOutlined, CloseOutlined, Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { updateUsageFeesDirectDebitAsync } from "../sepaDirectDebitSlice";
import { selectAdminUser } from "../../homeSlice";

export const UsageFeesDirectDebitCell = (props: {
  companyUuid: string;
  hasUsageSepaDirectDebit: boolean;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const adminUser = useAppSelector(selectAdminUser);

  if (!adminUser?.email) {
    return <></>;
  }

  return (
    <StyledColumnButton>
      {props.hasUsageSepaDirectDebit ? (
        <StyledUsageFeesActions>
          <CheckOutlined />
          <Spacer x={2} />
          <ButtonDS
            singleIcon={{ icon: <CloseOutlined />, size: "S" }}
            format={"fill"}
            buttonType={"secondary"}
            onClick={() => {
              void dispatch(
                updateUsageFeesDirectDebitAsync({
                  companyUuid: props.companyUuid,
                  updatedBy: adminUser.email,
                  enabled: false,
                }),
              );
            }}
          />
        </StyledUsageFeesActions>
      ) : (
        <ButtonDS
          text={t("sepaDirectDebit.usageFees.activate")}
          format={"hug"}
          buttonType={"secondary"}
          sizeButton={"S"}
          onClick={() => {
            void dispatch(
              updateUsageFeesDirectDebitAsync({
                companyUuid: props.companyUuid,
                updatedBy: adminUser.email,
                enabled: true,
              }),
            );
          }}
        />
      )}
    </StyledColumnButton>
  );
};

const StyledColumnButton = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const StyledUsageFeesActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
